// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension=.ts"
// @generated from file protogen/member_service.proto (package protogen, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { Family } from "./advisors_service_pb.ts";
import { Task } from "./tasks_pb.ts";
import { Member, PlanUtilization, PublicAdvisor, UploadAttachment } from "./common_pb.ts";
import { BillingProduct } from "./billing_pb.ts";

/**
 * @generated from enum protogen.NotificationSettingsValue
 */
export enum NotificationSettingsValue {
  /**
   * @generated from enum value: NOTIFICATION_SETTINGS_VALUE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTIFICATION_SETTINGS_VALUE_ENABLED = 1;
   */
  ENABLED = 1,

  /**
   * @generated from enum value: NOTIFICATION_SETTINGS_VALUE_DISABLED = 2;
   */
  DISABLED = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(NotificationSettingsValue)
proto3.util.setEnumType(NotificationSettingsValue, "protogen.NotificationSettingsValue", [
  { no: 0, name: "NOTIFICATION_SETTINGS_VALUE_UNSPECIFIED" },
  { no: 1, name: "NOTIFICATION_SETTINGS_VALUE_ENABLED" },
  { no: 2, name: "NOTIFICATION_SETTINGS_VALUE_DISABLED" },
]);

/**
 * @generated from message protogen.GetMemberDetailsRequest
 */
export class GetMemberDetailsRequest extends Message<GetMemberDetailsRequest> {
  constructor(data?: PartialMessage<GetMemberDetailsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetMemberDetailsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMemberDetailsRequest {
    return new GetMemberDetailsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMemberDetailsRequest {
    return new GetMemberDetailsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMemberDetailsRequest {
    return new GetMemberDetailsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetMemberDetailsRequest | PlainMessage<GetMemberDetailsRequest> | undefined, b: GetMemberDetailsRequest | PlainMessage<GetMemberDetailsRequest> | undefined): boolean {
    return proto3.util.equals(GetMemberDetailsRequest, a, b);
  }
}

/**
 * @generated from message protogen.MemberCoreDocument
 */
export class MemberCoreDocument extends Message<MemberCoreDocument> {
  /**
   * @generated from field: string documentRef = 1;
   */
  documentRef = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: int64 lastUpdatedSec = 3;
   */
  lastUpdatedSec = protoInt64.zero;

  constructor(data?: PartialMessage<MemberCoreDocument>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.MemberCoreDocument";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "documentRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "lastUpdatedSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MemberCoreDocument {
    return new MemberCoreDocument().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MemberCoreDocument {
    return new MemberCoreDocument().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MemberCoreDocument {
    return new MemberCoreDocument().fromJsonString(jsonString, options);
  }

  static equals(a: MemberCoreDocument | PlainMessage<MemberCoreDocument> | undefined, b: MemberCoreDocument | PlainMessage<MemberCoreDocument> | undefined): boolean {
    return proto3.util.equals(MemberCoreDocument, a, b);
  }
}

/**
 * @generated from message protogen.MemberScheduledAction
 */
export class MemberScheduledAction extends Message<MemberScheduledAction> {
  /**
   * @generated from field: string agentCronRef = 1;
   */
  agentCronRef = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: string scheduleSummary = 3;
   */
  scheduleSummary = "";

  /**
   * @generated from field: string conversationRef = 4;
   */
  conversationRef = "";

  /**
   * @generated from field: string goal = 5;
   */
  goal = "";

  /**
   * @generated from field: int64 nextRunSec = 6;
   */
  nextRunSec = protoInt64.zero;

  /**
   * @generated from field: bool isPaused = 7;
   */
  isPaused = false;

  constructor(data?: PartialMessage<MemberScheduledAction>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.MemberScheduledAction";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agentCronRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "scheduleSummary", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "conversationRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "goal", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "nextRunSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "isPaused", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MemberScheduledAction {
    return new MemberScheduledAction().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MemberScheduledAction {
    return new MemberScheduledAction().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MemberScheduledAction {
    return new MemberScheduledAction().fromJsonString(jsonString, options);
  }

  static equals(a: MemberScheduledAction | PlainMessage<MemberScheduledAction> | undefined, b: MemberScheduledAction | PlainMessage<MemberScheduledAction> | undefined): boolean {
    return proto3.util.equals(MemberScheduledAction, a, b);
  }
}

/**
 * @generated from message protogen.DeleteScheduledActionRequest
 */
export class DeleteScheduledActionRequest extends Message<DeleteScheduledActionRequest> {
  /**
   * @generated from field: string agentCronRef = 1;
   */
  agentCronRef = "";

  constructor(data?: PartialMessage<DeleteScheduledActionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.DeleteScheduledActionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agentCronRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteScheduledActionRequest {
    return new DeleteScheduledActionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteScheduledActionRequest {
    return new DeleteScheduledActionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteScheduledActionRequest {
    return new DeleteScheduledActionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteScheduledActionRequest | PlainMessage<DeleteScheduledActionRequest> | undefined, b: DeleteScheduledActionRequest | PlainMessage<DeleteScheduledActionRequest> | undefined): boolean {
    return proto3.util.equals(DeleteScheduledActionRequest, a, b);
  }
}

/**
 * @generated from message protogen.DeleteScheduledActionResponse
 */
export class DeleteScheduledActionResponse extends Message<DeleteScheduledActionResponse> {
  constructor(data?: PartialMessage<DeleteScheduledActionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.DeleteScheduledActionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteScheduledActionResponse {
    return new DeleteScheduledActionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteScheduledActionResponse {
    return new DeleteScheduledActionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteScheduledActionResponse {
    return new DeleteScheduledActionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteScheduledActionResponse | PlainMessage<DeleteScheduledActionResponse> | undefined, b: DeleteScheduledActionResponse | PlainMessage<DeleteScheduledActionResponse> | undefined): boolean {
    return proto3.util.equals(DeleteScheduledActionResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetMemberDetailsResponse
 */
export class GetMemberDetailsResponse extends Message<GetMemberDetailsResponse> {
  /**
   * @generated from field: protogen.Family family = 1;
   */
  family?: Family;

  /**
   * @generated from field: repeated protogen.Task activeTasks = 2;
   */
  activeTasks: Task[] = [];

  /**
   * @generated from field: protogen.PublicAdvisor primaryAdvisor = 3;
   */
  primaryAdvisor?: PublicAdvisor;

  /**
   * @generated from field: protogen.Member member = 4;
   */
  member?: Member;

  /**
   * @generated from field: protogen.PlanUtilization planUtilization = 5;
   */
  planUtilization?: PlanUtilization;

  /**
   * @generated from field: protogen.NotificationSettings notificationSettings = 6;
   */
  notificationSettings?: NotificationSettings;

  /**
   * @generated from field: repeated protogen.MemberCoreDocument coreDocuments = 7;
   */
  coreDocuments: MemberCoreDocument[] = [];

  /**
   * @generated from field: repeated protogen.MemberScheduledAction scheduledActions = 8;
   */
  scheduledActions: MemberScheduledAction[] = [];

  constructor(data?: PartialMessage<GetMemberDetailsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetMemberDetailsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "family", kind: "message", T: Family },
    { no: 2, name: "activeTasks", kind: "message", T: Task, repeated: true },
    { no: 3, name: "primaryAdvisor", kind: "message", T: PublicAdvisor },
    { no: 4, name: "member", kind: "message", T: Member },
    { no: 5, name: "planUtilization", kind: "message", T: PlanUtilization },
    { no: 6, name: "notificationSettings", kind: "message", T: NotificationSettings },
    { no: 7, name: "coreDocuments", kind: "message", T: MemberCoreDocument, repeated: true },
    { no: 8, name: "scheduledActions", kind: "message", T: MemberScheduledAction, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMemberDetailsResponse {
    return new GetMemberDetailsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMemberDetailsResponse {
    return new GetMemberDetailsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMemberDetailsResponse {
    return new GetMemberDetailsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetMemberDetailsResponse | PlainMessage<GetMemberDetailsResponse> | undefined, b: GetMemberDetailsResponse | PlainMessage<GetMemberDetailsResponse> | undefined): boolean {
    return proto3.util.equals(GetMemberDetailsResponse, a, b);
  }
}

/**
 * @generated from message protogen.UpdateMembersFamilyRequest
 */
export class UpdateMembersFamilyRequest extends Message<UpdateMembersFamilyRequest> {
  /**
   * @generated from field: string familyRef = 1;
   */
  familyRef = "";

  /**
   * @generated from field: string updatedAddress = 2;
   */
  updatedAddress = "";

  /**
   * @generated from field: repeated protogen.Member newMembers = 3;
   */
  newMembers: Member[] = [];

  /**
   * @generated from field: repeated protogen.UpdateMembersFamilyRequest.UpdatedMember updatedMembers = 4;
   */
  updatedMembers: UpdateMembersFamilyRequest_UpdatedMember[] = [];

  constructor(data?: PartialMessage<UpdateMembersFamilyRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateMembersFamilyRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "familyRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "updatedAddress", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "newMembers", kind: "message", T: Member, repeated: true },
    { no: 4, name: "updatedMembers", kind: "message", T: UpdateMembersFamilyRequest_UpdatedMember, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateMembersFamilyRequest {
    return new UpdateMembersFamilyRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateMembersFamilyRequest {
    return new UpdateMembersFamilyRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateMembersFamilyRequest {
    return new UpdateMembersFamilyRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateMembersFamilyRequest | PlainMessage<UpdateMembersFamilyRequest> | undefined, b: UpdateMembersFamilyRequest | PlainMessage<UpdateMembersFamilyRequest> | undefined): boolean {
    return proto3.util.equals(UpdateMembersFamilyRequest, a, b);
  }
}

/**
 * @generated from message protogen.UpdateMembersFamilyRequest.UpdatedMember
 */
export class UpdateMembersFamilyRequest_UpdatedMember extends Message<UpdateMembersFamilyRequest_UpdatedMember> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string updatedPhone = 2;
   */
  updatedPhone = "";

  constructor(data?: PartialMessage<UpdateMembersFamilyRequest_UpdatedMember>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateMembersFamilyRequest.UpdatedMember";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "updatedPhone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateMembersFamilyRequest_UpdatedMember {
    return new UpdateMembersFamilyRequest_UpdatedMember().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateMembersFamilyRequest_UpdatedMember {
    return new UpdateMembersFamilyRequest_UpdatedMember().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateMembersFamilyRequest_UpdatedMember {
    return new UpdateMembersFamilyRequest_UpdatedMember().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateMembersFamilyRequest_UpdatedMember | PlainMessage<UpdateMembersFamilyRequest_UpdatedMember> | undefined, b: UpdateMembersFamilyRequest_UpdatedMember | PlainMessage<UpdateMembersFamilyRequest_UpdatedMember> | undefined): boolean {
    return proto3.util.equals(UpdateMembersFamilyRequest_UpdatedMember, a, b);
  }
}

/**
 * @generated from message protogen.UpdateMembersFamilyResponse
 */
export class UpdateMembersFamilyResponse extends Message<UpdateMembersFamilyResponse> {
  /**
   * @generated from field: protogen.Family family = 1;
   */
  family?: Family;

  constructor(data?: PartialMessage<UpdateMembersFamilyResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateMembersFamilyResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "family", kind: "message", T: Family },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateMembersFamilyResponse {
    return new UpdateMembersFamilyResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateMembersFamilyResponse {
    return new UpdateMembersFamilyResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateMembersFamilyResponse {
    return new UpdateMembersFamilyResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateMembersFamilyResponse | PlainMessage<UpdateMembersFamilyResponse> | undefined, b: UpdateMembersFamilyResponse | PlainMessage<UpdateMembersFamilyResponse> | undefined): boolean {
    return proto3.util.equals(UpdateMembersFamilyResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetBillingPortalUrlRequest
 */
export class GetBillingPortalUrlRequest extends Message<GetBillingPortalUrlRequest> {
  constructor(data?: PartialMessage<GetBillingPortalUrlRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetBillingPortalUrlRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBillingPortalUrlRequest {
    return new GetBillingPortalUrlRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBillingPortalUrlRequest {
    return new GetBillingPortalUrlRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBillingPortalUrlRequest {
    return new GetBillingPortalUrlRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetBillingPortalUrlRequest | PlainMessage<GetBillingPortalUrlRequest> | undefined, b: GetBillingPortalUrlRequest | PlainMessage<GetBillingPortalUrlRequest> | undefined): boolean {
    return proto3.util.equals(GetBillingPortalUrlRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetBillingPortalUrlResponse
 */
export class GetBillingPortalUrlResponse extends Message<GetBillingPortalUrlResponse> {
  /**
   * @generated from field: string url = 1;
   */
  url = "";

  constructor(data?: PartialMessage<GetBillingPortalUrlResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetBillingPortalUrlResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBillingPortalUrlResponse {
    return new GetBillingPortalUrlResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBillingPortalUrlResponse {
    return new GetBillingPortalUrlResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBillingPortalUrlResponse {
    return new GetBillingPortalUrlResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetBillingPortalUrlResponse | PlainMessage<GetBillingPortalUrlResponse> | undefined, b: GetBillingPortalUrlResponse | PlainMessage<GetBillingPortalUrlResponse> | undefined): boolean {
    return proto3.util.equals(GetBillingPortalUrlResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetAdvisorProfileRequest
 */
export class GetAdvisorProfileRequest extends Message<GetAdvisorProfileRequest> {
  /**
   * @generated from field: string advisorRef = 1;
   */
  advisorRef = "";

  constructor(data?: PartialMessage<GetAdvisorProfileRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAdvisorProfileRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "advisorRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAdvisorProfileRequest {
    return new GetAdvisorProfileRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAdvisorProfileRequest {
    return new GetAdvisorProfileRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAdvisorProfileRequest {
    return new GetAdvisorProfileRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAdvisorProfileRequest | PlainMessage<GetAdvisorProfileRequest> | undefined, b: GetAdvisorProfileRequest | PlainMessage<GetAdvisorProfileRequest> | undefined): boolean {
    return proto3.util.equals(GetAdvisorProfileRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetAdvisorProfileResponse
 */
export class GetAdvisorProfileResponse extends Message<GetAdvisorProfileResponse> {
  /**
   * @generated from field: protogen.PublicAdvisor profile = 1;
   */
  profile?: PublicAdvisor;

  constructor(data?: PartialMessage<GetAdvisorProfileResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAdvisorProfileResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profile", kind: "message", T: PublicAdvisor },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAdvisorProfileResponse {
    return new GetAdvisorProfileResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAdvisorProfileResponse {
    return new GetAdvisorProfileResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAdvisorProfileResponse {
    return new GetAdvisorProfileResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetAdvisorProfileResponse | PlainMessage<GetAdvisorProfileResponse> | undefined, b: GetAdvisorProfileResponse | PlainMessage<GetAdvisorProfileResponse> | undefined): boolean {
    return proto3.util.equals(GetAdvisorProfileResponse, a, b);
  }
}

/**
 * @generated from message protogen.SubmitReferralRequest
 */
export class SubmitReferralRequest extends Message<SubmitReferralRequest> {
  /**
   * @generated from field: string email = 1;
   */
  email = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  constructor(data?: PartialMessage<SubmitReferralRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SubmitReferralRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubmitReferralRequest {
    return new SubmitReferralRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubmitReferralRequest {
    return new SubmitReferralRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubmitReferralRequest {
    return new SubmitReferralRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SubmitReferralRequest | PlainMessage<SubmitReferralRequest> | undefined, b: SubmitReferralRequest | PlainMessage<SubmitReferralRequest> | undefined): boolean {
    return proto3.util.equals(SubmitReferralRequest, a, b);
  }
}

/**
 * @generated from message protogen.SubmitReferralResponse
 */
export class SubmitReferralResponse extends Message<SubmitReferralResponse> {
  constructor(data?: PartialMessage<SubmitReferralResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SubmitReferralResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubmitReferralResponse {
    return new SubmitReferralResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubmitReferralResponse {
    return new SubmitReferralResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubmitReferralResponse {
    return new SubmitReferralResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SubmitReferralResponse | PlainMessage<SubmitReferralResponse> | undefined, b: SubmitReferralResponse | PlainMessage<SubmitReferralResponse> | undefined): boolean {
    return proto3.util.equals(SubmitReferralResponse, a, b);
  }
}

/**
 * @generated from message protogen.SubmitReactivationRequest
 */
export class SubmitReactivationRequest extends Message<SubmitReactivationRequest> {
  /**
   * @generated from field: string membershipPlan = 1;
   */
  membershipPlan = "";

  /**
   * @generated from field: string advisorPreference = 2;
   */
  advisorPreference = "";

  constructor(data?: PartialMessage<SubmitReactivationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SubmitReactivationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "membershipPlan", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "advisorPreference", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubmitReactivationRequest {
    return new SubmitReactivationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubmitReactivationRequest {
    return new SubmitReactivationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubmitReactivationRequest {
    return new SubmitReactivationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SubmitReactivationRequest | PlainMessage<SubmitReactivationRequest> | undefined, b: SubmitReactivationRequest | PlainMessage<SubmitReactivationRequest> | undefined): boolean {
    return proto3.util.equals(SubmitReactivationRequest, a, b);
  }
}

/**
 * @generated from message protogen.SubmitReactivationResponse
 */
export class SubmitReactivationResponse extends Message<SubmitReactivationResponse> {
  constructor(data?: PartialMessage<SubmitReactivationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SubmitReactivationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubmitReactivationResponse {
    return new SubmitReactivationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubmitReactivationResponse {
    return new SubmitReactivationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubmitReactivationResponse {
    return new SubmitReactivationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SubmitReactivationResponse | PlainMessage<SubmitReactivationResponse> | undefined, b: SubmitReactivationResponse | PlainMessage<SubmitReactivationResponse> | undefined): boolean {
    return proto3.util.equals(SubmitReactivationResponse, a, b);
  }
}

/**
 * @generated from message protogen.NotificationSettings
 */
export class NotificationSettings extends Message<NotificationSettings> {
  /**
   * @generated from field: protogen.NotificationSettingsValue email = 2;
   */
  email = NotificationSettingsValue.UNSPECIFIED;

  /**
   * @generated from field: protogen.NotificationSettingsValue push = 3;
   */
  push = NotificationSettingsValue.UNSPECIFIED;

  /**
   * @generated from field: protogen.NotificationSettingsValue smsBot = 4;
   */
  smsBot = NotificationSettingsValue.UNSPECIFIED;

  constructor(data?: PartialMessage<NotificationSettings>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.NotificationSettings";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 2, name: "email", kind: "enum", T: proto3.getEnumType(NotificationSettingsValue) },
    { no: 3, name: "push", kind: "enum", T: proto3.getEnumType(NotificationSettingsValue) },
    { no: 4, name: "smsBot", kind: "enum", T: proto3.getEnumType(NotificationSettingsValue) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationSettings {
    return new NotificationSettings().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationSettings {
    return new NotificationSettings().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationSettings {
    return new NotificationSettings().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationSettings | PlainMessage<NotificationSettings> | undefined, b: NotificationSettings | PlainMessage<NotificationSettings> | undefined): boolean {
    return proto3.util.equals(NotificationSettings, a, b);
  }
}

/**
 * @generated from message protogen.UpdateMemberNotificationsRequest
 */
export class UpdateMemberNotificationsRequest extends Message<UpdateMemberNotificationsRequest> {
  /**
   * @generated from field: protogen.NotificationSettings settings = 1;
   */
  settings?: NotificationSettings;

  constructor(data?: PartialMessage<UpdateMemberNotificationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateMemberNotificationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "settings", kind: "message", T: NotificationSettings },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateMemberNotificationsRequest {
    return new UpdateMemberNotificationsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateMemberNotificationsRequest {
    return new UpdateMemberNotificationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateMemberNotificationsRequest {
    return new UpdateMemberNotificationsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateMemberNotificationsRequest | PlainMessage<UpdateMemberNotificationsRequest> | undefined, b: UpdateMemberNotificationsRequest | PlainMessage<UpdateMemberNotificationsRequest> | undefined): boolean {
    return proto3.util.equals(UpdateMemberNotificationsRequest, a, b);
  }
}

/**
 * @generated from message protogen.UpdateMemberNotificationsResponse
 */
export class UpdateMemberNotificationsResponse extends Message<UpdateMemberNotificationsResponse> {
  /**
   * @generated from field: protogen.NotificationSettings settings = 1;
   */
  settings?: NotificationSettings;

  constructor(data?: PartialMessage<UpdateMemberNotificationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateMemberNotificationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "settings", kind: "message", T: NotificationSettings },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateMemberNotificationsResponse {
    return new UpdateMemberNotificationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateMemberNotificationsResponse {
    return new UpdateMemberNotificationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateMemberNotificationsResponse {
    return new UpdateMemberNotificationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateMemberNotificationsResponse | PlainMessage<UpdateMemberNotificationsResponse> | undefined, b: UpdateMemberNotificationsResponse | PlainMessage<UpdateMemberNotificationsResponse> | undefined): boolean {
    return proto3.util.equals(UpdateMemberNotificationsResponse, a, b);
  }
}

/**
 * @generated from message protogen.UpdateMemberProfileRequest
 */
export class UpdateMemberProfileRequest extends Message<UpdateMemberProfileRequest> {
  /**
   * @generated from field: protogen.UploadAttachment profileImage = 1;
   */
  profileImage?: UploadAttachment;

  /**
   * @generated from field: bool shouldUpdateProfileImage = 2;
   */
  shouldUpdateProfileImage = false;

  constructor(data?: PartialMessage<UpdateMemberProfileRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateMemberProfileRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profileImage", kind: "message", T: UploadAttachment },
    { no: 2, name: "shouldUpdateProfileImage", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateMemberProfileRequest {
    return new UpdateMemberProfileRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateMemberProfileRequest {
    return new UpdateMemberProfileRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateMemberProfileRequest {
    return new UpdateMemberProfileRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateMemberProfileRequest | PlainMessage<UpdateMemberProfileRequest> | undefined, b: UpdateMemberProfileRequest | PlainMessage<UpdateMemberProfileRequest> | undefined): boolean {
    return proto3.util.equals(UpdateMemberProfileRequest, a, b);
  }
}

/**
 * @generated from message protogen.UpdateMemberProfileResponse
 */
export class UpdateMemberProfileResponse extends Message<UpdateMemberProfileResponse> {
  /**
   * @generated from field: protogen.Member member = 1;
   */
  member?: Member;

  constructor(data?: PartialMessage<UpdateMemberProfileResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateMemberProfileResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "member", kind: "message", T: Member },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateMemberProfileResponse {
    return new UpdateMemberProfileResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateMemberProfileResponse {
    return new UpdateMemberProfileResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateMemberProfileResponse {
    return new UpdateMemberProfileResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateMemberProfileResponse | PlainMessage<UpdateMemberProfileResponse> | undefined, b: UpdateMemberProfileResponse | PlainMessage<UpdateMemberProfileResponse> | undefined): boolean {
    return proto3.util.equals(UpdateMemberProfileResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListDigitalSubscriptionProductsRequest
 */
export class ListDigitalSubscriptionProductsRequest extends Message<ListDigitalSubscriptionProductsRequest> {
  constructor(data?: PartialMessage<ListDigitalSubscriptionProductsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListDigitalSubscriptionProductsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDigitalSubscriptionProductsRequest {
    return new ListDigitalSubscriptionProductsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDigitalSubscriptionProductsRequest {
    return new ListDigitalSubscriptionProductsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDigitalSubscriptionProductsRequest {
    return new ListDigitalSubscriptionProductsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListDigitalSubscriptionProductsRequest | PlainMessage<ListDigitalSubscriptionProductsRequest> | undefined, b: ListDigitalSubscriptionProductsRequest | PlainMessage<ListDigitalSubscriptionProductsRequest> | undefined): boolean {
    return proto3.util.equals(ListDigitalSubscriptionProductsRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListDigitalSubscriptionProductsResponse
 */
export class ListDigitalSubscriptionProductsResponse extends Message<ListDigitalSubscriptionProductsResponse> {
  /**
   * @generated from field: repeated protogen.BillingProduct products = 1;
   */
  products: BillingProduct[] = [];

  constructor(data?: PartialMessage<ListDigitalSubscriptionProductsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListDigitalSubscriptionProductsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "products", kind: "message", T: BillingProduct, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDigitalSubscriptionProductsResponse {
    return new ListDigitalSubscriptionProductsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDigitalSubscriptionProductsResponse {
    return new ListDigitalSubscriptionProductsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDigitalSubscriptionProductsResponse {
    return new ListDigitalSubscriptionProductsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListDigitalSubscriptionProductsResponse | PlainMessage<ListDigitalSubscriptionProductsResponse> | undefined, b: ListDigitalSubscriptionProductsResponse | PlainMessage<ListDigitalSubscriptionProductsResponse> | undefined): boolean {
    return proto3.util.equals(ListDigitalSubscriptionProductsResponse, a, b);
  }
}

/**
 * @generated from message protogen.UpgradeDigitalSubscriptionRequest
 */
export class UpgradeDigitalSubscriptionRequest extends Message<UpgradeDigitalSubscriptionRequest> {
  /**
   * @generated from field: string productName = 1;
   */
  productName = "";

  /**
   * @generated from field: int32 priceAmountCents = 2;
   */
  priceAmountCents = 0;

  /**
   * @generated from field: string paymentMethodId = 3;
   */
  paymentMethodId = "";

  /**
   * @generated from field: string couponId = 4;
   */
  couponId = "";

  constructor(data?: PartialMessage<UpgradeDigitalSubscriptionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpgradeDigitalSubscriptionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "productName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "priceAmountCents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "paymentMethodId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "couponId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpgradeDigitalSubscriptionRequest {
    return new UpgradeDigitalSubscriptionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpgradeDigitalSubscriptionRequest {
    return new UpgradeDigitalSubscriptionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpgradeDigitalSubscriptionRequest {
    return new UpgradeDigitalSubscriptionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpgradeDigitalSubscriptionRequest | PlainMessage<UpgradeDigitalSubscriptionRequest> | undefined, b: UpgradeDigitalSubscriptionRequest | PlainMessage<UpgradeDigitalSubscriptionRequest> | undefined): boolean {
    return proto3.util.equals(UpgradeDigitalSubscriptionRequest, a, b);
  }
}

/**
 * @generated from message protogen.UpgradeDigitalSubscriptionResponse
 */
export class UpgradeDigitalSubscriptionResponse extends Message<UpgradeDigitalSubscriptionResponse> {
  /**
   * @generated from field: protogen.Family family = 1;
   */
  family?: Family;

  constructor(data?: PartialMessage<UpgradeDigitalSubscriptionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpgradeDigitalSubscriptionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "family", kind: "message", T: Family },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpgradeDigitalSubscriptionResponse {
    return new UpgradeDigitalSubscriptionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpgradeDigitalSubscriptionResponse {
    return new UpgradeDigitalSubscriptionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpgradeDigitalSubscriptionResponse {
    return new UpgradeDigitalSubscriptionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpgradeDigitalSubscriptionResponse | PlainMessage<UpgradeDigitalSubscriptionResponse> | undefined, b: UpgradeDigitalSubscriptionResponse | PlainMessage<UpgradeDigitalSubscriptionResponse> | undefined): boolean {
    return proto3.util.equals(UpgradeDigitalSubscriptionResponse, a, b);
  }
}

/**
 * @generated from message protogen.NotifySupportUpgradeRequestRequest
 */
export class NotifySupportUpgradeRequestRequest extends Message<NotifySupportUpgradeRequestRequest> {
  constructor(data?: PartialMessage<NotifySupportUpgradeRequestRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.NotifySupportUpgradeRequestRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotifySupportUpgradeRequestRequest {
    return new NotifySupportUpgradeRequestRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotifySupportUpgradeRequestRequest {
    return new NotifySupportUpgradeRequestRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotifySupportUpgradeRequestRequest {
    return new NotifySupportUpgradeRequestRequest().fromJsonString(jsonString, options);
  }

  static equals(a: NotifySupportUpgradeRequestRequest | PlainMessage<NotifySupportUpgradeRequestRequest> | undefined, b: NotifySupportUpgradeRequestRequest | PlainMessage<NotifySupportUpgradeRequestRequest> | undefined): boolean {
    return proto3.util.equals(NotifySupportUpgradeRequestRequest, a, b);
  }
}

/**
 * @generated from message protogen.NotifySupportUpgradeRequestResponse
 */
export class NotifySupportUpgradeRequestResponse extends Message<NotifySupportUpgradeRequestResponse> {
  constructor(data?: PartialMessage<NotifySupportUpgradeRequestResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.NotifySupportUpgradeRequestResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotifySupportUpgradeRequestResponse {
    return new NotifySupportUpgradeRequestResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotifySupportUpgradeRequestResponse {
    return new NotifySupportUpgradeRequestResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotifySupportUpgradeRequestResponse {
    return new NotifySupportUpgradeRequestResponse().fromJsonString(jsonString, options);
  }

  static equals(a: NotifySupportUpgradeRequestResponse | PlainMessage<NotifySupportUpgradeRequestResponse> | undefined, b: NotifySupportUpgradeRequestResponse | PlainMessage<NotifySupportUpgradeRequestResponse> | undefined): boolean {
    return proto3.util.equals(NotifySupportUpgradeRequestResponse, a, b);
  }
}

